import { SideSheetContentCol } from '@bechtel/gds';
import { CommodityType, WorkPackage } from '@bechtel/types';
import React, { FC, Fragment } from 'react';
import { BlockHeadingStyled } from '../styled';
import MultiCommodityList from './commodity-list';
import { CommodityTypes as CommodityTypeList } from './commodity-types';
import { MultiBlockSideSheetContentColStyled } from '../../styled';
import { Trans } from '@lingui/macro';

interface CommoditiesSelectionProps {
  workPackageId: WorkPackage['id'];
  commodityTypes?: CommodityType[];
  selectedCommodityTypeId: string;
}

export const CommoditiesSelection: FC<CommoditiesSelectionProps> = ({
  workPackageId,
  commodityTypes,
  selectedCommodityTypeId,
}) => {
  return (
    <Fragment>
      <MultiBlockSideSheetContentColStyled>
        <BlockHeadingStyled>
          <Trans>Select a Commodity Type</Trans>
        </BlockHeadingStyled>
        <CommodityTypeList commodityTypes={commodityTypes} />
      </MultiBlockSideSheetContentColStyled>
      <SideSheetContentCol style={{ overflowY: 'hidden' }}>
        <BlockHeadingStyled>
          <Trans>Select Commodities to Block</Trans>
        </BlockHeadingStyled>
        {selectedCommodityTypeId && (
          <MultiCommodityList workPackageId={workPackageId} selectedCommodityTypeId={selectedCommodityTypeId} />
        )}
      </SideSheetContentCol>
    </Fragment>
  );
};
